module.exports = __webpack_public_path__ + "static/media/brand-logo-dark-cropped.b9b04c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-logo-dark-cropped.png
// module id = 379
// module chunks = 1